import request from '@/utils/request'

import { User } from '@/types/user'

// eslint-disable-next-line
export function Create(u: User): Promise<User> {
  return request.post('/user', u)
}

// eslint-disable-next-line
export function Find(): Promise<User[]> {
  return request.get('/user')
}

// eslint-disable-next-line
export function Get(id: number): Promise<User> {
  return request.get(`/user/${id}`)
}

// eslint-disable-next-line
export function Patch(id: number, u: User): Promise<User> {
  return request.patch(`/user/${id}`, u)
}

// eslint-disable-next-line
export function Delete(id: number): Promise<User> {
  return request.delete(`/user/${id}`)
}
